import * as vp from 'vopay';
import { useContext, useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import AccountContext from '../Accounts/AccountContext';
import EftWithdrawTransactionInfo from './EftWithdrawTransactionInfo';
import useFetchEFTWithdrawTransaction from '../../hooks/useApi/useFetchEFTWithdrawTransaction';
import LinkedTransactionInfo from './LinkedTransactionInfo';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const EftWithdrawTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { TransactionID, Type } = props;
  const { details } = useContext(AccountContext);
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [parentTransactions, setParentTransactions] = useState<vp.LinkedTransactionsMap>();
  let token = '';
  if (details[accountId]) {
    token = details[accountId].token;
  }
  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.EftWithdrawTransactionResponse>();

  useEffect(() => {
    if (Type === vp.TransactionType.EFT_WITHDRAWAL) {
      getEftWithdrawTransaction(TransactionID);
    }

    setIsDataFeched(true);
  }, [currentTransactionId]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftWithdrawTransaction).length > 0 && eftWithdrawTransaction.ParentTransaction) {
      const subTransactionsList: vp.LinkedTransactionsMap = Object.values(eftWithdrawTransaction.ParentTransaction);

      setParentTransactions(subTransactionsList);
    }
  }, [eftWithdrawTransaction]);

  useEffect(() => {
    if (eftWithdrawTransaction) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && transaction.TransactionID !== '' && <EftWithdrawTransactionInfo transaction={transaction} />}
      {parentTransactions && <LinkedTransactionInfo LinkedTransactions={parentTransactions} />}
    </div>
  );
};

export default EftWithdrawTransactionContainer;
